module.exports = __webpack_public_path__ + "static/april-2-7c0b40c3679cba40fcb081c2ea8cd0d6.png";